import { faGears } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Select, Button, Col, Typography, Modal, Space, Form } from "antd";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
  createLocalAudioTrack,
  createLocalTracks,
  createLocalVideoTrack,
} from "twilio-video";
import { RoomContext } from "../../RoomContext";

// Hook to get the current video devices
export const useVideoDevices = () => {
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      // Return the deviceId and label
      let videoInputDevices = devices
        .filter((device) => device.kind === "videoinput")
        .map((d) => ({ value: d.deviceId, label: d.label }));
      setDevices(videoInputDevices);
    });
  }, []);

  return devices;
};

// Hook to get the current audio devices
export const useAudioDevices = () => {
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      // Return the deviceId and label
      let audioInputDevices = devices
        .filter((device) => device.kind === "audioinput")
        .map((d) => ({ value: d.deviceId, label: d.label }));
      setDevices(audioInputDevices);
    });
  }, []);

  return devices;
};

// React component to select audio/video device and toggle each device on/off
// To be used in the lobby before joining a room
// https://www.twilio.com/docs/video/configuring-audio-video-input-and-output-devices
const VideoDevices = () => {
  const { videoTrack, setVideoTrack } = useContext(RoomContext);
  const [videoPreview, setVideoPreview] = useState(videoTrack);

  return (
    <div style={{ textAlign: "center" }} className="local">
      <div id="carisity-video-preview"></div>
    </div>
  );
};

// Button to allow a user to change device settings
export const DeviceSettings = ({ type, text }) => {
  const { videoDevice, setVideoDevice, audioDevice, setAudioDevice } =
    useContext(RoomContext);
  const videoDevices = useVideoDevices();
  const audioDevices = useAudioDevices();

  const SettingsModal = () => {
    Modal.info({
      icon: null,
      title: "Device Settings",
      content: (
        <>
          <Form layout="vertical">
            <Form.Item label="Camera">
              <Select
                defaultValue={videoDevice}
                options={videoDevices}
                onChange={(e) => setVideoDevice(e)}
              />
            </Form.Item>
            <Form.Item label="Microphone">
              <Select
                defaultValue={audioDevice}
                options={audioDevices}
                onChange={(e) => setAudioDevice(e)}
              />
            </Form.Item>
          </Form>
        </>
      ),
    });
  };
  return (
    <>
      <Button type={type} onClick={SettingsModal}>
        {text ? (
          <Space direction="horizontal">
            <FontAwesomeIcon icon={faGears} /> {text}
          </Space>
        ) : (
          <FontAwesomeIcon icon={faGears} />
        )}
      </Button>
    </>
  );
};

export default VideoDevices;
